import * as React from "react";
import { LineChart } from '@mui/x-charts';

const CustomMultiLineChart = ({ chart_data, isFullWidth }) => {

    const { chartType, type, chart_type, xAxis, yAxis, daily, weekly, data } = chart_data;
    const chartViewType = chartType || type || chart_type;
    const isMultipleTabs = daily && weekly;

    const getChartData = () => {
        const xAxisSeries = Array.from({ length: 10 }, (_, i) => `Day ${i + 1}`);
        const series = data.map(cat => ({
            data: cat?.trend,
            label: cat?.category,
            shape: 'circle', // Optional shape
            showMark:true,
        }));
        return { xAxisSeries, series };
    };

    const { xAxisSeries, series } = getChartData();

    const margin = { top: 20, bottom: 30, left: 60, right: 20 };

    return (
        <div style={isFullWidth ? styles.cardFull : styles.cardHalf}>
            <h3>{chart_data?.title || chart_data?.chart_name}</h3>
            <p>{chart_data?.description}</p>
            <LineChart
                height={300}
                xAxis={[{ scaleType: 'point', data: xAxisSeries }]}
                series={series}
                yAxis={[{ width: 50 }]}
                margin={margin}
            />
        </div>
    );
}

const styles = {
    cardHalf: {
        flex: 0.48,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
    cardFull: {
        flex: 1,
        padding: 20,
        border: '1px solid #ccc',
        borderRadius: '12px',
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'left',
    },
};

export default CustomMultiLineChart;